<script>
    import { resolveExportUrl } from "../../router.js";
    import TestExportLogs from "../components/testexportlogs.svelte";
    import wrappedFetch from "../../wrappedFetch.js";
    import { onMount } from "svelte";
    import Spinner from "../components/spinner.svelte";
    import NoDataFound from "../components/nodatainfo.svelte";
    import Message from "../components/message.svelte";
    import Button from "../components/button.svelte";
    import ModalConfirm from "../components/modalconfirm.svelte";
    export let providerId;
    let showConfirmModal = false;
    let titleProvider =
        providerId == 1 ? "Google" : providerId == 3 ? "Microsoft" : "";
    let isPageLoading = true;
    let testExportDetails;
    let isExportRunning = false;
    
    let exportStartTime = "";
    let interval;
    let exportEndTime;
    let currentTime;
    let isTestRun = false;
    let disableButton = false;

    // $:{console.log('currentTime',currentTime)}

    const GetExportStatus = async () => {
        var resp = await wrappedFetch(
            `/api/TestExport/CheckTestExportStatus?providerId=${providerId}`,
            { method: "post" }
        );

        var result = await resp.json();

        isExportRunning = result.isExportRunning;
        isTestRun = result.isTestRun;
        exportStartTime = result.exportStartTime;
        exportEndTime = Date.parse(result.exportEndTime);
        //  if(!isExportRunning && exportEndTime > currentTime )
        //   await getTestRunStats();

        

        if (isExportRunning || result.isInQueue ) {

            disableButton = true;
        } else {
            disableButton = false;
        }

        //isInQueue

    };

    onMount(async () => {
        isPageLoading = true;
        await GetExportStatus();
        setCheckInterval();
        await getTestRunStats();
        // let resp = await wrappedFetch(
        //     `/api/testexport/GetTestRunStats?providerId=${providerId}`,
        //     { method: "post" }
        // );
        // testExportDetails = (await resp.json()).result;
        // if(logNumbers)
        //     params={pupilsProcessed : logNumbers.processedPupils,pupilsPending:logNumbers.pendingPupils,pupilsErrors:0,staffProcessed:logNumbers.processedStaff,staffPending:logNumbers.pendingStaff,staffErrors:0}
        isPageLoading = false;

        

    });

    const getTestRunStats = async () => {
        let resp = await wrappedFetch(
            `/api/testexport/GetTestRunStats?providerId=${providerId}`,
            { method: "post" }
        );
        testExportDetails = (await resp.json()).result;
        currentTime = Date.parse(new Date());
    };

    const setCheckInterval = () => {
        interval = setInterval(async () => {
            GetExportStatus();
            // if (isExportRunning)
            //     GetExportStatus();
            //  else {
            //  clearInterval(interval);
            // //     HasConfigChanged();
            //  }
            
            if (!isExportRunning && exportEndTime > currentTime) {
                await getTestRunStats();
            }
        }, 4000);
    };
    const syncTest = async () => {
        await SetQueueExport();
        showConfirmModal = false;
        await wrappedFetch(
            `/api/TestExport/RunTestSync?providerId=${providerId}`,
            { method: "post" }
        );
        await GetExportStatus();
        setCheckInterval();
    };

    const SetQueueExport = async () => {
        
        showConfirmModal = false;

        await wrappedFetch(
            `/api/cloudConfig/SetQueueExport?providerId=${providerId}`,
            { method: "post" }
        );

    };

</script>

<style>
    .error {
        color: red;
        font-weight: 500;
    }
    .processed {
        color: #2b76e9;
        font-weight: 500;
    }
    .pending {
        color: orange; /* rgb(236, 80, 76); */
        font-weight: 500;
    }
    .material-icons {
        vertical-align: bottom;
    }

    h5 {
        color: #2e817d; /*  #ec504c; */
    }
</style>

<svelte:head>
    <title>{titleProvider} Test Export Logs | Wavenet Nimbus</title>
</svelte:head>

<div class="row">
    <div class="col-12">
        <a class="btn btn-grey mb-3" href="/app/export/{providerId}/summary">
            <i class="fas fa-arrow-left" />
            Back
        </a>
    </div>
</div>

{#if isPageLoading}
    <Spinner />
{:else}
    <h1>Test Export</h1>
    <p>
        Running this will take several minutes.You can return to this page later
        to view the results.
    </p>

    <!-- <button type="button" title="" style="min-width:82px;min-height:35px;" class="btn btn-primary" data="" on:click={syncTest}>Run Test</button> -->
    <br />
    {#if isExportRunning && isTestRun}
        <Message
            message="Test sync currently in progress. Configurations can not be changed while sync is in progress. <br /> Current test sync started at {exportStartTime} " />
        <Spinner marginTop="15px" marginBottom="50px" />
    {:else if testExportDetails == null}
        <NoDataFound infoText="No Data Found">
            <p>
                Please ensure the test run has been done. Please click the 'Run
                Test' button below to do test sync.
            </p>
            <Button
                buttonClass={'btn-primary'}
                bind:disabled={disableButton}
                buttonText="Run Test"
                loadingText="Running"
                on:click={() => (showConfirmModal = true)} />
        </NoDataFound>
    {:else}
        <!-- <h1>Test Export</h1>
        <p>Running this will take several minutes.You can return to this page later to view the results.</p> -->
        <Button
            buttonClass={'btn-primary'}
            bind:disabled={disableButton}
            buttonText="Re Run Test"
            loadingText="Running"
            on:click={() => (showConfirmModal = true)} />
        <!-- <button type="button" title="" style="min-width:82px;min-height:35px;" class="btn btn-primary" data="" on:click={syncTest}>Re Run Test</button> -->
        <br />
        <br />
        <p>This test export was run at {testExportDetails.syncEndTime}</p>
        <div class="card-deck">
            <TestExportLogs
                urlDetails={resolveExportUrl(providerId, '/testexport/pupil')}
                {testExportDetails}>
                <div slot="heading">
                    <h5><span class="material-icons">school</span> Pupil</h5>
                </div>
                <div slot="body">
                    <ul>
                        <li>
                            <p>
                                <span
                                    class="pending">{testExportDetails.countPupilCreated}</span>
                                new accounts auto created.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span
                                    class="pending">{testExportDetails.countPupilMatched}</span>
                                will be matched automatically.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span
                                    class="pending">{testExportDetails.countPupilPending}</span>
                                will need manual matching.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span
                                    class="pending">{testExportDetails.countPupilDisabled}</span>
                                accounts will be disabled.
                            </p>
                        </li>
                    </ul>
                </div>
            </TestExportLogs>

            <!-- <br/> -->
            <TestExportLogs
                urlDetails={resolveExportUrl(providerId, '/testexport/staff')}>
                <div slot="heading">
                    <h5>
                        <span class="material-icons">assignment_ind</span>Staff
                    </h5>
                </div>
                <div slot="body">
                    <ul>
                        <li>
                            <p>
                                <span
                                    class="pending">{testExportDetails.countStaffCreated}</span>
                                new accounts auto created.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span
                                    class="pending">{testExportDetails.countStaffMatched}</span>
                                will be matched automatically.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span
                                    class="pending">{testExportDetails.countStaffPending}</span>
                                will need manual matching.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span
                                    class="pending">{testExportDetails.countStaffDisabled}</span>
                                accounts will be disabled.
                            </p>
                        </li>
                    </ul>
                </div>
            </TestExportLogs>

            <br />

            <TestExportLogs
                urlDetails={resolveExportUrl(providerId, '/testexport/groups')}
                {testExportDetails}>
                <div slot="heading">
                    <h5><span class="material-icons">groups</span> Groups</h5>
                </div>
                <div slot="body">
                    <ul>
                        <li>
                            <p>
                                <span
                                    class="pending">{testExportDetails.countGroupCreated}</span>
                                new groups created.
                            </p>
                        </li>
                        <li>
                            <p>
                                <span
                                    class="pending">{testExportDetails.countGroupUpdated}</span>
                                groups updated.
                            </p>
                        </li>
                    </ul>
                </div>
            </TestExportLogs>
        </div>

        <br/>
        <p>If you are happy with this, you can go back to the summary page and run your export; or change your settings and rerun the test.</p>
    {/if}
{/if}

<ModalConfirm
    bind:showModal={showConfirmModal}
    zindex="1052"
    sizeClass="modal-md"
    targetClass="confirm-options"
    showCancel={true}
    on:confirm={syncTest}>
    <div slot="header">
        <h4 class="title">Are you sure you want to run a test export?</h4>
    </div>
    <div slot="content">
        Changes are typically shown within a few minutes automatically.This may
        be useful to see what changes will occur.
    </div>
</ModalConfirm>
